import type { HttpClient } from '@adapters/HttpClient';

export interface ProductOverlayStockSummary {
  disponible: number;
  reservado: number;
}

export interface ProductOverlayLocationStock {
  id: string;
  code: string;
  typeName: string;
  stock: number;
}

/** Adapter local del overlay Product (evita shared → módulo CreateEdit). */
export class ProductOverlayStockApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getStockSummary(productId: string | number): Promise<ProductOverlayStockSummary | null> {
    const raw = await this.httpClient.get<any>(`/products/${productId}`);
    const stock = raw?.stock;
    if (!stock || typeof stock !== 'object') {
      return null;
    }
    return {
      disponible: Number(stock.disponible ?? 0) || 0,
      reservado: Number(stock.reservado ?? 0) || 0,
    };
  }

  async getLocationsWithStock(productId: string | number): Promise<ProductOverlayLocationStock[]> {
    const query = new URLSearchParams({
      product_ids: String(productId),
      per_page: '1000',
      page: '1',
      order_by: 'id',
      order_direction: 'desc',
    }).toString();

    const raw = await this.httpClient.get<any>(`/locations?${query}`, undefined, {}, false);
    const list = Array.isArray(raw) ? raw : (raw?.data ?? []);

    return list.map((loc: any) => ({
      id: String(loc.id),
      code: String(loc.code ?? ''),
      typeName: String(loc.type?.name ?? ''),
      stock: typeof loc.stock === 'number' ? loc.stock : 0,
    }));
  }
}
